
































import { Vue, Component, Prop } from 'vue-property-decorator';
import brandModule from '../../store/modules/brand.module';

@Component
export default class EmailAssetDialog extends Vue {
  @Prop({ default: false }) onlyIconShows!: boolean;

  shareDialog = false;

  email = '';

  get brandColor() {
    if (!brandModule.brand) {
      return 'blue';
    }
    return brandModule.brand.secondary_color;
  }

  shareAsset() {
    this.$emit('sendAsset', this.email);
    this.shareDialog = false;
  }
}
